import React from 'react'

export type Placement = 'Header' | 'Section' | 'Modal'
export type PlacementInternalName = string

export interface IPlacementContext {
  placement?: Placement
  placementInternalName?: PlacementInternalName
}

export const PlacementContext = React.createContext<IPlacementContext>({})
